"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonVariant = exports.ButtonSize = exports.ButtonIconPosition = exports.ButtonColorScheme = void 0;
var ButtonVariant;
exports.ButtonVariant = ButtonVariant;
(function (ButtonVariant) {
  ButtonVariant["Primary"] = "primary";
  ButtonVariant["Secondary"] = "secondary";
  ButtonVariant["Tertiary"] = "tertiary";
})(ButtonVariant || (exports.ButtonVariant = ButtonVariant = {}));
var ButtonColorScheme;
exports.ButtonColorScheme = ButtonColorScheme;
(function (ButtonColorScheme) {
  ButtonColorScheme["Default"] = "default";
  ButtonColorScheme["DarkBackground"] = "darkBackground";
})(ButtonColorScheme || (exports.ButtonColorScheme = ButtonColorScheme = {}));
var ButtonSize;
exports.ButtonSize = ButtonSize;
(function (ButtonSize) {
  ButtonSize["Default"] = "default";
  ButtonSize["Small"] = "small";
})(ButtonSize || (exports.ButtonSize = ButtonSize = {}));
var ButtonIconPosition;
exports.ButtonIconPosition = ButtonIconPosition;
(function (ButtonIconPosition) {
  ButtonIconPosition["Leading"] = "leading";
  ButtonIconPosition["Trailing"] = "trailing";
})(ButtonIconPosition || (exports.ButtonIconPosition = ButtonIconPosition = {}));